export type LikertScale = 'VERY_HIGH' | 'HIGH' | 'LOW' | 'VERY_LOW' | 'UNKNOWN' | 'NOT_SET';

export const LikertScaleLabels: { [likert in LikertScale]: string } = {
  HIGH: 'ある程度',
  LOW: 'わずかに',
  VERY_HIGH: '大いに',
  VERY_LOW: 'まったくない',
  UNKNOWN: 'わからない',
  NOT_SET: ''
};

export const LikertScaleKeys: { [likert in LikertScale]: likert } = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  UNKNOWN: 'UNKNOWN',
  VERY_HIGH: 'VERY_HIGH',
  VERY_LOW: 'VERY_LOW',
  NOT_SET: 'NOT_SET'
};
